export default __webpack_public_path__ + "static/big-ben-d66909546a85632eef242c78d7f6e7ed.png";